/**
 * Customer bookings: the Appointments card on a customer's page - what they
 * have booked, how often they came, and what they told the shop.
 * Conventions: see `common.ts`. Status names and answer Yes/No come from
 * `bookings`, so the diary and this card read the same.
 */
const customerBookings: Record<string, string> = {
  title: 'Appointments',
  description: 'What this customer has booked with you, latest first.',
  open_bookings: 'Open bookings',
  loading: 'Loading appointments…',
  load_failed: 'Could not load this customer’s appointments.',
  empty: 'No appointments yet.',

  'stats.completed': 'Visits completed',
  'stats.upcoming': 'Upcoming',
  'stats.no_shows': 'No-shows',
  'stats.cancelled': 'Cancelled',
  'stats.last_visit': 'Last visit',
  'stats.next_visit': 'Next appointment',
  'stats.none': 'None yet',

  'list.label': 'Appointments for this customer',
  'list.with': 'with {name}',
  'list.answers': 'Their answers',
  'list.show_all': 'Show all {count}',
  'list.show_fewer': 'Show fewer',
  'list.capped': 'Showing the latest {shown} of {total}.',

  // Booking payments, beside each appointment.
  'payment.paid': 'Paid {amount}',
  'payment.refunded': 'Refunded {amount}',
  'payment.package': 'Package session',
  'payment.at_venue': 'Pay at the venue',
  'payment.awaiting': 'Awaiting payment',
  'payment.due_at_venue': '{amount} due at the venue',
};

export default customerBookings;
